import { AsyncState } from './types';

export const asyncDefaultState: AsyncState<any> = {
  loading: false,
  payload: null,
  errors: null,
  currentRequestId: null
};
